import { createActions } from './createActions.ts';
import { deleteActions } from './deleteActions.ts';
import { duplicateActions } from './duplicateActions.ts';
import { favoriteActions } from './favoriteActions.ts';
import { fetchActions } from './fetchActions.ts';
import { shareActions } from './shareActions.ts';
import { updateActions } from './updateActions.ts';

/**
 * Combined actions object for the snippets store.
 * Actions are grouped by concern for better organization and testability:
 * - fetchActions: Data fetching and cache management
 * - createActions: Snippet creation with UI integration (flags, quick insert)
 * - duplicateActions: Snippet duplication with UI integration (flags, quick insert)
 * - deleteActions: Snippet deletion (API + local state; pass editorAPI in options for quick insert removal)
 * - shareActions: Share/unshare with error flag UI
 */
export const actions = {
	...fetchActions,
	...createActions,
	...duplicateActions,
	...deleteActions,
	...updateActions,
	...favoriteActions,
	...shareActions,
};
